import AnimatedProperty from './AnimatedProperty'

class Position extends AnimatedProperty<[number, number]> {
	getValueAtTime(time: number): [number, number] {
		return this.lerp(this.lastFrame.v, this.nextFrame.v, this.getElapsed(time))
	}
}

export default Position
